import React from 'react';

import { DownloadNonPaginatedDataCSV } from 'components/DownloadCSV';
import dayjs from 'dayjs';
import { Options } from 'export-to-csv';
import useClassUsage from 'hooks/reports/utilization/class-usage/useClassUsage';
import { ClassUsageReportItem } from 'types/generated/models/ClassUsageReportItem';
import { getDayNameFromWeekdayNumber } from 'utils/weekdays';

import { ClassUsageSearchFilters } from '../../SearchFilters';

interface DownloadCSVProps {
  className?: string;
  searchFilters: ClassUsageSearchFilters;
}

const csvOptions: Options = {
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalSeparator: '.',
  showLabels: true,
  useBom: true,
  useKeysAsHeaders: true,
};

const dataToRow = (d: ClassUsageReportItem): { [key: string]: any } => ({
  Class: d.classTypeName,
  Day:
    d.weekday === 'All'
      ? d.weekday
      : getDayNameFromWeekdayNumber(d.weekday as unknown as 1 | 2 | 3 | 4 | 5 | 6 | 7),
  'Start Time': d.startTime,
  Coach: d.coachFullName,
  Sessions: d.totalSessions,
  'Available Spots': d.availableSpots,
  'Reserved Spots': d.reservedSpots,
  'Avg Attendance': Math.ceil(d.averageAttendance),
  Attended: d.attended,
  'No Shows': d.noShows,
  'Late Cancels': d.lateCancels,
  'Utilization Rate': `${(d.utilizationRate * 100).toFixed(1)}%`,
  'Change Percentage': d.changePercentage !== null ? `${(d.changePercentage * 100).toFixed(1)}%` : '',
});

const DownloadCSV = ({ className, searchFilters }: DownloadCSVProps): JSX.Element => {
  return (
    <DownloadNonPaginatedDataCSV
      useList={useClassUsage}
      dataToRow={dataToRow}
      csvOptions={csvOptions}
      hookOptions={searchFilters}
      className={className}
      reportType='class-usage'
      startDate={searchFilters.startDate ? dayjs(searchFilters.startDate).format('YYYY-MM-DD') : null}
      endDate={searchFilters.endDate ? dayjs(searchFilters.endDate).format('YYYY-MM-DD') : null}
    />
  );
};

export default DownloadCSV;
